import { createApp } from 'vue'
import pinia from './store'
import './index.css'
import '@shopexperts/admin-pages-editor/style.css'
import { configureAdminPagesEditor } from '@shopexperts/admin-pages-editor'
import App from './App.vue'
import router from "./router";
import { shouldHideHelpScoutBeacon } from "@/app/utils/helpScoutBeaconVisibility";
import { api } from '@/services/api.service'
import { useAuthStore } from '@/store/auth.ts'
import "vue-search-select/dist/VueSearchSelect.css"
import { SafeAreaPlugin, createApiPlugin } from "@shopexperts/shared"
import type { Plugin } from 'vue'
import { ApiClient } from './api/apiClient';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import * as Sentry from "@sentry/vue";
import { initHelpScoutBeacon } from "@shopexperts/shared";
import { initPostHog } from '@/app/composables/usePostHog';
import Clarity from '@microsoft/clarity'
const app = createApp(App)
const profilePreviewUrl = import.meta.env.VITE_PROFILE_PREVIEW_URL
  || (import.meta.env.DEV ? 'http://localhost:3000/freelancer-preview' : 'https://shopexperts.com/freelancer-preview')
const publicSiteUrl = import.meta.env.VITE_WEBSITE_URL
  || import.meta.env.VITE_PUBLIC_SITE_URL
  || (import.meta.env.DEV ? 'http://localhost:3000' : 'https://shopexperts.com')
const betaSiteUrl = import.meta.env.VITE_WEBSITE_BETA_URL || 'https://beta.shopexperts.com'

configureAdminPagesEditor({ profilePreviewUrl, publicSiteUrl, betaSiteUrl })

// Initialize PostHog analytics
initPostHog()

if (import.meta.env.PROD && import.meta.env.VITE_CLARITY_PROJECT_ID) {
  Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID)
}

if (!shouldHideHelpScoutBeacon(window.location.pathname)) {
  initHelpScoutBeacon('6a409334-7d5c-4b2d-96eb-20616f4960d9')
}

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    sendDefaultPii: true
});

app.use(SafeAreaPlugin as Plugin)
app.use(createApiPlugin({
    baseUrl: `${import.meta.env.VITE_API_BASE_URL}/api/v2`,
    client: new ApiClient()
}) as Plugin)
// Install TanStack Vue Query
const queryClient = new QueryClient()
app.use(VueQueryPlugin, { queryClient })
app.use(pinia)

const token = localStorage.getItem('CURRENT_TOKEN')
const user = localStorage.getItem('CURRENT_USER')

if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`

    const auth = useAuthStore()
    auth.token = token
    auth.user = user ? JSON.parse(user) : null
    auth.identifyCurrentUser()
}

app.use(router)
app.mount('#app')
